import { render } from "./SearchModule.vue?vue&type=template&id=1c3b86ac"
import script from "./SearchModule.vue?vue&type=script&lang=js"
export * from "./SearchModule.vue?vue&type=script&lang=js"

import "./SearchModule.vue?vue&type=style&index=0&id=1c3b86ac&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__